import { Navigate, Route, Routes } from 'react-router-dom';

import { RunPage } from './RunPage';
import { ScenariosPage } from './ScenariosPage';
import { TestUsersPage } from './TestUsersPage';

/**
 * Sub-router for the `/internal/accountctl/*` surface. The outer route in
 * `index.tsx` already gates this section behind `RequirePalmettoFinanceUser`
 * so every child here can assume the caller is internal.
 *
 * Paths:
 *   /internal/accountctl                → ScenariosPage (default + run history)
 *   /internal/accountctl/runs/:id       → RunPage (live SSE timeline)
 *   /internal/accountctl/test-users     → TestUsersPage (shared editor)
 */
export const AccountctlApp = () => {
  return (
    <Routes>
      <Route index element={<ScenariosPage />} />
      <Route path="runs/:id" element={<RunPage />} />
      <Route path="test-users" element={<TestUsersPage />} />
      <Route path="*" element={<Navigate to="/internal/accountctl" replace />} />
    </Routes>
  );
};
